// import React from "react";
// import PropTypes from "prop-types";

// const Pagination = ({ currentPage, totalPages, onPageChange }) => {
//   const handlePrevious = () => {
//     if (currentPage > 1) onPageChange(currentPage - 1);
//   };

//   const handleNext = () => {
//     if (currentPage < totalPages) onPageChange(currentPage + 1);
//   };

//   const renderPageNumbers = () => {
//     const pages = [];

//     // Show first page, current page, and last page, with ellipses in between
//     for (let i = 1; i <= totalPages; i++) {
//       if (
//         i === 1 || // Always show the first page
//         i === totalPages || // Always show the last page
//         (i >= currentPage - 1 && i <= currentPage + 1) // Show current, one before, and one after
//       ) {
//         pages.push(
//           <button
//             key={i}
//             className={`px-4 py-2 mx-1 ${i === currentPage ? "bg-agBg" : "bg-transparent"} text- rounded-md`}
//             onClick={() => onPageChange(i)}
//           >
//             {i}
//           </button>,
//         );
//       } else if (
//         i === currentPage - 2 ||
//         i === currentPage + 2 // Add ellipses for skipped pages
//       ) {
//         pages.push(
//           <span key={i} className="mx-1">
//             ...
//           </span>,
//         );
//       }
//     }
//     return pages;
//   };

//   return (
//     <div className="flex justify-between mt-4">
//       {/* Previous Button */}
//       <button
//         className={`px-4 py-2 rounded-md border ${currentPage === 1 ? "text-gray-200" : "text-agLightGray border-gray-300 hover:bg-agBg"}`}
//         onClick={handlePrevious}
//         disabled={currentPage === 1}
//       >
//         &larr; PREVIOUS
//       </button>

//       {/* Page Numbers */}
//       <div className="flex items-center text-agLightGray">
//         {renderPageNumbers()}
//       </div>

//       {/* Next Button */}
//       <button
//         className={`px-4 py-2 rounded-md border ${currentPage === totalPages ? "text-gray-200" : "text-agLightGray border-gray-300 hover:bg-agBg"}`}
//         onClick={handleNext}
//         disabled={currentPage === totalPages}
//       >
//         NEXT &rarr;
//       </button>
//     </div>
//   );
// };

// Pagination.propTypes = {
//   currentPage: PropTypes.number.isRequired,
//   totalPages: PropTypes.number.isRequired,
//   onPageChange: PropTypes.func.isRequired,
// };

// export default Pagination;

import React from "react";
import PropTypes from "prop-types";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const renderPageNumbers = () => {
    const pages = [];

    // Show first page, current page, and last page, with ellipses in between
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 || // Always show the first page
        i === totalPages || // Always show the last page
        (i >= currentPage - 1 && i <= currentPage + 1) // Show current, one before, and one after
      ) {
        pages.push(
          <button
            key={i}
            className={`px-4 py-2 mx-1 ${
              i === currentPage ? "bg-agBg" : "bg-transparent"
            } text- rounded-md`}
            onClick={() => onPageChange(i)}
          >
            {i}
          </button>,
        );
      } else if (
        i === currentPage - 2 ||
        i === currentPage + 2 // Add ellipses for skipped pages
      ) {
        pages.push(
          <span key={i} className="mx-1">
            ...
          </span>,
        );
      }
    }
    return pages;
  };

  return (
    <div className="flex justify-between mt-4">
      {/* Previous Button */}
      <button
        className={`px-4 py-2 rounded-md border ${
          currentPage === 1
            ? "text-gray-200"
            : "text-agLightGray border-gray-300 hover:bg-agBg"
        }`}
        onClick={handlePrevious}
        disabled={currentPage === 1}
      >
        <span className="hidden md:inline-block">&larr; PREVIOUS</span>
        <span className="inline-block md:hidden">&larr;</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center text-agLightGray">
        {renderPageNumbers()}
      </div>

      {/* Next Button */}
      <button
        className={`px-4 py-2 rounded-md border ${
          currentPage === totalPages
            ? "text-gray-200"
            : "text-agLightGray border-gray-300 hover:bg-agBg"
        }`}
        onClick={handleNext}
        disabled={currentPage === totalPages}
      >
        <span className="hidden md:inline-block">NEXT &rarr;</span>
        <span className="inline-block md:hidden">&rarr;</span>
      </button>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
